const clientConfig = {
  siteUrl: "https://kenworthychiropractic.com/backend",
};

export default clientConfig;
